export default __webpack_public_path__ + "static/media/sex.6bd7048e.svg";